import {
  CheckMultiSelectInput,
  CheckMultiSelectMenuProps,
} from "./CheckMultiSelectInput";
import {
  TagMultiSelectInput,
  TagMultiSelectMenuProps,
} from "./TagMultiSelectInput";
import { BaseGenericType } from "./types";

type TagMultiSelectVariantProps<T> = TagMultiSelectMenuProps<T> & {
  variant?: "tag";
};

type CheckMultiSelectVariantProps<T> = CheckMultiSelectMenuProps<T> & {
  variant: "check";
};

export type MultiSelectMenuProps<T> =
  | TagMultiSelectVariantProps<T>
  | CheckMultiSelectVariantProps<T>;

export function MultiSelectInput<T extends BaseGenericType>(
  props: MultiSelectMenuProps<T>
) {
  if (props.variant === "check") {
    return <CheckMultiSelectInput<T> {...props} />;
  }

  return <TagMultiSelectInput<T> {...props} />;
}
